<template>
  <div class="marketing-text-component mtc">
    <div v-if="isMarketingTextLoading && disableLoadingSpinner === false">
      <loading-spinner />
    </div>
    <div v-else>
      <b-row v-if="isCollapsible" class="m-0">
        <b-col md="6" class="p-0">
          <h3>{{ marketingTitle }}</h3>
        </b-col>
        <b-col md="6" class="p-0 pb-2">
          <b-button v-b-toggle.marketingText class="btn btn-smallLightBlueButton pull-right">
            {{ getContentItem("ShowHide") }}
          </b-button>
        </b-col>
      </b-row>
      <b-collapse id="marketingText" :visible="!isCollapsible">
        <wysiwyg-html-area class="mtc__content" :html="marketingText" />
      </b-collapse>
    </div>
  </div>
</template>

<script>
  import { mapGetters }       from "vuex"
  import { CatalogService }   from "@/services/CatalogService"
  import { LoadingSpinner }   from "@/components/Elements"
  import { ErrorLogService }  from "@/services/ErrorLogService"
  import { constants }        from "@/const"
  import { WysiwygHtmlArea }  from "@/components/Elements/WysiwygHtmlArea"

  export default {
    components: {
      LoadingSpinner,
      WysiwygHtmlArea
    },
    props: {
      categoryId: {
        default: 0
      },
      disableLoadingSpinner: {
        type: Boolean,
        default: false
      },
      isCollapsible:  {
        type: Boolean,
        default: false
      },
      marketingTitle: {
        type: String,
        default: null
      }
    },
    computed: {
      ...mapGetters(["getContentItem"]),
    },
    data: () => {
      return {
        marketingText: "",
        isMarketingTextLoading: false
      }
    },
    created() {
      let self = this;
      this.isMarketingTextLoading = true
      CatalogService.GetCategoryContentByTypes(this.categoryId, [constants.CATEGORY_CONTENT_TYPES.MARKETING_TEXT])
        .then(marketingText => {
          let marketingTextDto = marketingText.data
            .find( x => x.ContentType === constants.CATEGORY_CONTENT_TYPES.MARKETING_TEXT)
          
          self.marketingText = marketingTextDto === undefined 
            ? "" 
            : marketingTextDto.Content
        })
        .catch(err => {
          ErrorLogService.LogException(err)         
        })
        .finally(() => {
          // Force the bootstrap table classes.
          let tableElements = document.querySelectorAll(".marketing-text-wrapper table");

          [...tableElements].forEach(function(element){
            if(element !== null && !element.className.includes("table table-bordered" )){
              element.className += " table table-bordered";
            }
          });

          self.isMarketingTextLoading = false
          self.$emit("loaded");
        })
    }
  }
</script>

<style>
.marketing-text-component {
  width: 100%;
  padding-top: 15px;
}
</style>